import { useEffect } from "react";
import { LoginForm } from "../content/Login";
import { LoginImage } from "../assets/images";
import { usePersistData } from "../store";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const navigate = useNavigate();
  const { user } = usePersistData();

  useEffect(() => {
    if (user?.designation) {
      if (user?.isFirstLogin === false) {
        navigate("/");
      } else {
      }
    }
  }, [user, navigate]);

  return (
    <div>
      <div className="grid grid-cols-2 bg-white">
        <LoginForm />
        <div className="bg-border h-screen items-center justify-center flex">
          <span className="max-w-[600px] max-h-[600px]">
            <img src={LoginImage} alt="Login" className="w-[600px] h-[600px]" />
          </span>
        </div>
      </div>
    </div>
  );
};

export default Login;
